import styled from "@emotion/styled";
import { GridList } from "react-aria-components";

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.colors.grey.x600};
  margin-top: ${({ theme }) => theme.spacing.smd};
  margin-bottom: ${({ theme }) => theme.spacing.smd};
`;

export const StyledGridList = styled(GridList)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  width: 100%;
`;

export const StyledLeftAddon = styled.div`
  align-self: flex-start;
`;

export const StyledRightAddon = styled.div`
  align-self: flex-start;
`;
